<template lang="pug">
    header.headx
        a.back(href="http://www.iknowhere.co.kr/collection")
            img.in(src='~@/assets/arrow.svg')
        a.brand(href="http://www.iknowhere.co.kr")
            img.in(src='~@/assets/brand.png')
        img.share(src='~@/assets/share.svg', @click="share = true")
        div.share__pop(v-show="share", @click.self="share = false")
            img.share__close(src="~@/assets/close.svg", @click="share = false")
            a.share__item(:href="$options.share.facebook", target="popup", @click="openPopup('facebook')")
                img.share__icon(src="~@/assets/share-facebook.svg", style="height:24px;")
            a.share__item(:href="$options.share.twitter", target="popup", @click="openPopup('twitter')")
                img.share__icon(src="~@/assets/share-twitter.svg", style="height:20px;")
            a.share__item(:href="$options.share.naver", target="popup", @click="openPopup('naver')")
                img.share__icon(src="~@/assets/share-naver.svg", style="height:20px;")
            img.share__icon.share__item(src="~@/assets/share-url.svg",
            style="height:20px;"
            v-clipboard:copy="$options.share.url",
            v-clipboard:success="handleCopy")
</template>

<script>
const titleEncoded = window.encodeURIComponent('오늘은 경리단, 아는동네 로컬 프로젝트')
const urlEncoded = window.encodeURIComponent('https://festival.iknowhere.co.kr/gyeongridan')

export default {
    name: 'Headx',
    share: {
        facebook: `https://www.facebook.com/dialog/share?app_id=1211459058934552&display=popup&href=${urlEncoded}`,
        twitter: `https://twitter.com/intent/tweet?text=${titleEncoded}&url=${urlEncoded}`,
        naver: `http://share.naver.com/web/shareView.nhn?url=${urlEncoded}&title=${titleEncoded}`,
        url: 'https://festival.iknowhere.co.kr/gyeongridan'
    },
    data() {
        return {
            share: false
        }
    },
    methods: {
        openPopup(type) {
            this.$ga.event('Share', type, '오늘은 경리단')
            const top = window.innerHeight / 2 - 200 + window.screenY
            const left = window.innerWidth / 2 - 300 + window.screenX
            window.open(this.$options.share[type], 'popup', `width=600,height=400,top=${top},left=${left}`)
        },
        handleCopy() {
            this.$ga.event('Share', 'url', '오늘은 경리단')
            this.$toasted.show('복사했습니다.', {
                duration: 1500
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_parts';

.headx {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 18px 24px 0;
    position: absolute;
    z-index: 10;
}

.in {
    width: 100%;
}

.back {
    width: 29px;
    display: block;
    margin-right: auto
}

.brand {
    width: 87px;
    display: block;
    align-self: baseline
}

.share {
    width: 33px;
    margin-left: auto
}

.share__pop {
    width: 100%;
    height: 100%;
    background: transparentize($color: #000, $amount: .15);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}
.share__icon {
    display: block;
}
.share__item {
    & + & {
        margin-left: 36px;
    }
}
.share__close {
    position: absolute;
    top: 32px;
    right: 24px;
    @include media(sm) {
        top: 48px;
        right: 32px;
    }
}
</style>
